import { create } from 'zustand';

/**
 * Transient app-shell UI state for chrome shared across screens. Headers are
 * pinned (`sticky top-0`) on every screen, so there is no collapse signal.
 */
interface UiState {
  navDrawerOpen: boolean;
  currentPath: string | null;
  previousPath: string | null;
  setNavDrawerOpen: (open: boolean) => void;
  trackPath: (path: string) => void;
  openNavDrawer: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  navDrawerOpen: false,
  currentPath: null,
  previousPath: null,
  setNavDrawerOpen: (navDrawerOpen) => set({ navDrawerOpen }),
  trackPath: (path) =>
    set((state) => {
      if (state.currentPath === path) return state;
      return {
        previousPath: state.currentPath,
        currentPath: path,
      };
    }),
  openNavDrawer: () => set({ navDrawerOpen: true }),
}));
